var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/UserClassifierRepo/DynamicGroup/DynamicBimElementReference.ts";
import * as t from 'io-ts';
import { BimElement } from '../../BimEntity';
import { createPredicate } from '../../createPredicate';
import { Id } from '../../Id';
import { ReferenceSource } from '../../SourceProps';
import { Version } from '../../Version';
export var DynamicBimElementReference;

(function (_DynamicBimElementReference) {
  var type = _DynamicBimElementReference.type = 'DynamicBimElementReference';
  var io = _DynamicBimElementReference.io = t.recursion('DynamicBimElementReference', function () {
    return t.type({
      type: t.literal(type),
      id: Id,
      parentDynamicGroupId: Id,
      parentClassifierId: Id,
      parentClassifierVersion: Version,
      element: BimElement.io,
      source: ReferenceSource
    });
  });
  var is = _DynamicBimElementReference.is = createPredicate(type);
})(DynamicBimElementReference || (DynamicBimElementReference = {}));